import {DomainStore} from 'shared/store';
import { makeAutoObservable } from 'mobx';
import {t} from 'shared/core';
import {endpoints, types} from 'main/tools';
import {successAlert} from 'shared/tools';
import {Calendar} from 'main/stores/calendars';
import {Company} from 'main/stores/company';
import _ from 'lodash';

class CalendarDirectoryState {
  store = new DomainStore();
  history;

  errors = {};
  legacyCalendars = [];
  company;

  constructor() {
    makeAutoObservable(this, {
      store: false,
      history: false
    });
  }

  receiveProps({history}) {
    this.history = history;
  }

  async load() {
    await this.store._compose([
      endpoints.CALENDARS,
      endpoints.CURRENT_COMPANY
    ]);

    this.legacyCalendars = this.store._getAll(types.CALENDAR, Calendar);
    this.company = new Company(
      this.store._getSingle(types.COMPANY)
    );
  }

  async toggleLegacyCalendar(legacyCalendar, value) {
    legacyCalendar.merge({enabled: value});

    const {model, errors} = await this.store.put(
      endpoints.CALENDAR.TOGGLE.with(legacyCalendar.id),
      types.CALENDAR,
      legacyCalendar
    );
    this.errors = errors;

    if (model) {
      successAlert(t('company_settings.calendars.Calendar updated!'));
    }
  }

  async removeSegmentCalendar(segmentCalendar) {
    await this.store.destroy(segmentCalendar);
    successAlert(t('company_settings.calendars.Deleted custom calendar.'));
  }

  goToEditSegmentCalendar(segmentCalendar) {
    const id = _.get(segmentCalendar, 'id', '');
    this.history.push(`/calendars/edit/${id}`);
  }
}

export default CalendarDirectoryState;
